
import "./Footer.css"

const Footer = () => {
    return (



<footer className="footer mt-auto py-3 ">
    <div className="footerText">
        <p>Säker och tillgänglig kommunikation för Sverige</p>
    </div>
    <div className="container-fluid">
        <div className="footerLinks row">
            <div className="col-12">
                <a href="https://www.pts.se/" target="_blank" className="footerLogo">
                    <img src="https://dsa.pts.se/pts_logotyp_2024-sidfot-inverterad.svg" alt="Länk till startsidan på pts.se" style={{ height: '40px', marginLeft: '-7px' }} /></a>
                    <a href="https://www.pts.se/kontakt/" target="_blank">Kontakt</a>
                    <span className="divider"></span><a href="https://www.pts.se/om-oss/behandling-av-personuppgifter/" target="_blank">Personuppgifter</a>
                    <span className="divider"></span><a href="https://www.pts.se/om-oss/om-pts.se/kakor-pa-webbplatsen/kakor-pa-pts-e-tjanster/" target="_blank">Kakor</a>
                
                    <span className="divider"></span><a href="https://www.pts.se/om-oss/om-pts.se/tillganglighetsredogorelse-for-pts-digitala-tjanster/" target="_blank">Tillgänglighet</a>
                    <span className="divider"></span><a href="https://www.pts.se/kontakt/alla-e-tjanster/" target="_blank">E-tjänster</a>
                    
                    </div>
            </div>
        </div>
    </footer>
    )
}

export default Footer;